import React from "react"
import upperFirst from "lodash/upperFirst"
import { loadScript } from "./load-script"
import { loadStyle } from "./load-style"
import { loadSettings } from "./load-settings"
import { useStyles } from "app/forms/data/use-styles"
import { createFontImportUrl } from "./create-font-import-url"

function templateWrapper(TemplateComponent, { css, settings, cleanup }) {
  function BuiltTemplate(props) {
    const styles = useStyles()

    const fonts = [
      ...new Set(
        styles.all
          .filter(style => {
            const parts = style.name.split(".")

            return parts[1] == "font-family"
          })
          .map(style => style.value.split(",")[0])
      )
    ]

    const fontImportUrl = createFontImportUrl(fonts)

    const variables = styles.all
      .map(style => {
        const [name, property] = style.name.split(".")
        const units = [
          "border-radius",
          "border-width",
          "font-size",
          "letter-spacing"
        ].includes(property)
          ? "px"
          : ""

        return `--${name}-${property}: ${style.value}${units};`
      })
      .join(" ")
    return (
      <>
        {fontImportUrl && <link rel="stylesheet" href={fontImportUrl} />}
        <style
          dangerouslySetInnerHTML={{ __html: `:root{ ${variables} }` }}
        ></style>
        <TemplateComponent {...props} />
      </>
    )
  }

  BuiltTemplate.css = css.join("\n")
  BuiltTemplate.settings = settings
  BuiltTemplate.cleanup = cleanup
  BuiltTemplate.displayName = TemplateComponent.displayName

  return BuiltTemplate
}

export function Template({ name, url }) {
  if (!url) {
    url = `https://pages.convertkit.com/templates/${name}`
  }

  return {
    layout: async layoutName => {
      const componentName = `${name} ${layoutName || ""}`
        .split(/\s|-/)
        .map(upperFirst)
        .join("")

      const path = layoutName ? `${name}.${layoutName}` : name

      let cssUrls = [`${url}/${name}.css?date=${Date.now()}`]

      if (layoutName) {
        cssUrls.push(`${url}/${path}.css?date=${Date.now()}`)
      }

      const [[script], settings] = await Promise.all([
        loadScript(`${url}/${path}.js`),
        loadSettings(`${url}/${name}.settings.json`)
      ])

      const css = await Promise.all(cssUrls.map(loadStyle))

      const component = window.__templates[componentName]

      const cleanup = () => {
        script.remove()
      }

      return templateWrapper(component, { css, settings, cleanup })
    }
  }
}
